class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    console.log('[CartNotif] open() called → adding active class to #cart-notification');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log('[CartNotif] renderContents called. key:', parsedState && parsedState.key);
    console.log('[CartNotif] parsedState.sections:', parsedState && parsedState.sections ? Object.keys(parsedState.sections) : 'MISSING/NULL');
    this.cartItemKey = parsedState.key;
    try {
      this.getSectionsToRender().forEach((section) => {
        console.log('[CartNotif] Updating section:', section.id);
        const html = parsedState.sections[section.id];
        if (!html) console.warn('[CartNotif] ⚠️ Section HTML is null/undefined for:', section.id);
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          html,
          section.selector
        );
        console.log('[CartNotif] ✅ Updated section:', section.id);
      });
    } catch (e) {
      console.error('[CartNotif] ❌ forEach crashed:', e);
    }

    if (this.header) this.header.reveal();
    console.log('[CartNotif] Calling open()');
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector) || parsed.querySelector('.shopify-section');
    return el ? el.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
